import React, { createContext, useState } from 'react'
import usePersistedState from '../hooks/usePersistedState'
export const LanguageContext = createContext(
	navigator.language.startsWith('en') ? 'english' : 'french'
)

const LanguageProvider = ({ children }) => {
	const [language, setLanguage] = usePersistedState(
		navigator.language.startsWith('en') ? 'english' : 'french',
		'language'
	)
	return (
		<LanguageContext.Provider value={{ language, setLanguage }}>
			{children}
		</LanguageContext.Provider>
	)
}

export default LanguageProvider
